<template>
  <v-container class="ma-0 pa-0 mw-100">
    <v-card class="px-5 px-md-13 px-sm-7 px-lg-16 py-5 py-md-8 py-sm-5 py-lg-10">
      <v-row>
        <v-col cols="12">
          <header-medium :text="$t('HomePage.header.check')" />
        </v-col>
      </v-row>
      <v-sheet>
        <v-col v-if="multipleFiles && !showEditor" class="px-0">
          <v-data-table :headers="headers" :items="files" item-key="name">
            <template v-slot:[`item.edit`]="{ item }">
              <v-icon medium @click="startEditor(item)"> mdi-pencil</v-icon>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-icon medium :color="getIcon(item) == 'mdi-check-circle-outline' ? 'green' : 'red'"> {{ getIcon(item) }}</v-icon>
            </template>

            <template v-slot:no-data>
              {{ $t("Headers.no_data") }}
            </template>
          </v-data-table>
        </v-col>
        <v-col v-if="showEditor" class="px-0">
          <v-row v-if="attachedFiles.length > 0">
            <v-col cols="12">
              <v-alert border="top" colored-border color="primary" elevation="2">
                <v-row align="center">
                  <v-col class="grow">
                    Dieses Dokument enthält einen Anhang, welcher ebenfalls
                    signiert wird.
                  </v-col>
                </v-row>
              </v-alert>
            </v-col>
          </v-row>
          <editor-preview :initialDoc="currentFile.file" :file_name="currentFile.name" :file_id="currentFile.id"
            :xfdf_annotations="currentFile.xfdf_annotations" :xfdf_signatures="currentFile.xfdf_signatures"
            :xfdf="currentFile.xfdf" :fileXFDF="currentFile.fileXFDF" ref="ref" @updateXfdf="updateXfdf($event)" />
          <v-row v-if="multipleFiles" class="pt-5">
            <v-col cols="12" sm="4" class="text-left">
              <custom-button :text="$t('AdminPage.Back')" @click="showEditor = false" color="red" />
            </v-col>
            <v-col cols="12" sm="8" class="text-right">
              <custom-button :text="$t('AdminPage.Confirm')" @click="setFinished(currentFile)" />
            </v-col>
          </v-row>
        </v-col>
        <v-row class="pt-5" v-if="(showEditor && !multipleFiles) || (!showEditor && multipleFiles)">
          <v-col cols="12" sm="4" class="text-left">
            <custom-button :text="$t('Navigation.cancel_workflow')" color="red" @click="cancel()"></custom-button>
          </v-col>
          <v-col cols="12" sm="8" class="text-right">
            <custom-button :text="$t('DetailsPage.labels.previous')" @click="nextPage(1)"></custom-button>
            <custom-button :text="textNextButton" @click="nextStep()"></custom-button>
          </v-col>
        </v-row>
      </v-sheet>
    </v-card>
  </v-container>
</template>
<script>
import i18n from "@/i18n";
import HeaderMedium from "../../components/ui/text/HeaderMedium.vue";
import HeaderSmall from "../../components/ui/text/HeaderSmall.vue";
import EditorPreview from "../../components/ui/other/EditorPreview";
import CustomButton from "../../components/ui/input/CustomButton";
import { log } from "@/helpers/logger";
import cookie from "vue-cookies";

export default {
  name: "documents",
  title: i18n.t("HomePage.header.check"),
  components: {
    HeaderMedium,
    EditorPreview,
    HeaderSmall,
    CustomButton,
  },
  data() {
    return {
      multipleFiles: false,
      showEditor: false,
      clicked: false,
      files: [],
      formFiles: [],
      attachedFiles: "",
      currentFile: "",
      color: "",
      headers: [
        { text: this.$t("AdminPage.Name"), value: "name" },
        {
          text: this.$t("AdminPage.Edit"),
          align: "center",
          value: "edit",
          sortable: false,
        },
        {
          text: this.$t("AdminPage.ConfirmEditHeader"),
          value: "status",
          align: "center",
          sortable: false,
        },
      ],
      ses: false,
      aes: false,
    };
  },
  created: async function () {
    this.$emit("step", 2);
    this.workflow = this.currentWorkflow;
    switch (this.workflow.signer_type) {
      case "s_signature":
        this.ses = true;
        this.aes = false;
        break;
      case "a_signature":
        this.ses = false;
        this.aes = true;
        break;
      case "q_signature":
        this.ses = false;
        this.aes = false;
        break;
      case "a_seal":
        this.ses = false;
        this.aes = true;
        break;
      case "q_seal":
        this.ses = false;
        this.aes = false;
        break;
    }

    await this.$store
      .dispatch("data/getWorkflowFiles")
      .then(async (data) => {
        log("Documents.created() - get files for workflow " + this.workflow.workflow_id, "info");
        this.files = data;
        this.currentFile = this.files[0];
      })
      .catch((err) => {
        log("Documents.created() - " + err.message, "error");
      });

    this.color = this.$vuetify.theme.themes.light.primary;

    if (this.files.length > 1) {
      this.multipleFiles = true;
    } else {
      this.showEditor = true;
    }
    this.$emit("loading", false);
  },
  computed: {
    textNextButton() {
      return (this.ses && !this.aes) ? this.$t('Navigation.signUnauthorized') : this.$t('Navigation.next')
    },
    currentWorkflow() {
      return this.$store.state.auth.workflow;
    },
  },
  methods: {
    hexToBase64(str) {
      return btoa(
        String.fromCharCode.apply(
          null,
          str
            .replace(/\r|\n/g, "")
            .replace(/([\da-fA-F]{2}) ?/g, "0x$1 ")
            .replace(/ +$/, "")
            .split(" ")
        )
      );
    },
    nextPage() {
      this.$store.state.auth.workflow = this.workflow;
      //this.$emit("navigate", val);
     
      this.$router.push(
        "/workflow/" +
        this.currentWorkflow.workflow_id +
        "/" +
        this.currentWorkflow.signer_id +
        "/credentials"
      );
    
      this.$store.commit("set_loading", true);
    },
    cancel() {
      this.$emit("refuse", true);
    },
    newFile(file) {
      this.currentFile = file;
    },
    async updateXfdf(xfdf) {
      this.files.forEach((file) => {
        if (file.id == this.currentFile.id) {
          let parser = new DOMParser();
          xfdf = parser.parseFromString(xfdf, "text/xml");
          for (const annot of xfdf.querySelectorAll(
            '[subject^="signature_"], [subject^="annotation_"], fileattachment, stamp, highlight, underline, strikeout, squiggly, square, text, circle, polygon, line, polyline'
          )) {
            annot.remove();
          }

          file.parsedXfdf = xfdf.getElementsByTagName("xfdf")[0].outerHTML;
         
        }
      });
    },
    nextStep() {
      if (!this.multipleFiles) {
        this.setFinished(this.currentFile);
      }
        if (this.ses && !this.aes) {
          this.signUnauthorized();
        } else if (!this.ses && this.aes) {
          this.getAuthentication();
        } else if (!this.ses && !this.aes) {
          this.getAuthenticationQES();
        }
      
    },
    async signUnauthorized() {
      this.clicked = true;
      await this.$store
        .dispatch("data/signWithoutAuth")
        .then(() => {
          this.$router.push("/summary/finished");
        })
        .catch((err) => {
          log("MainPage.Documents.signWithoutAuth() - " + err.message, "error");
        });
    },
    async getAuthentication() {
      this.clicked = true;
      this.$store.commit("auth/set_workflow", this.workflow);

      let files = { files: this.files };

      this.$store
        .dispatch("data/sendFilledOutFiles", files)
        .catch((err) =>
          log(
            "MainPage.Documents.getAuthentication() - " + err.message,
            "error"
          )
        );

      this.$router.push(
        "/workflow/" +
        this.currentWorkflow.workflow_id +
        "/" +
        this.currentWorkflow.signer_id +
        "/authenticate"
      );
    },
    async getAuthenticationQES() {
      this.clicked = true;
      this.$store.commit("auth/set_workflow", this.workflow);

      let files = { files: this.files };

      this.$store
        .dispatch("data/sendFilledOutFiles", files)
        .catch((err) =>
          log(
            "MainPage.Documents.getAuthentication() - " + err.message,
            "error"
          )
        );

      await this.$store
        .dispatch("data/getCertificate")
        .then((res) => {
          cookie.set("certificate_exists", res.certificate_exists, 60 * 30);

          switch (this.currentWorkflow.signer_type) {
            case "q_seal":
              if (
                res.phone_exists &&
                res.certificate_exists &&
                res.signer_seal_identified
              ) {
                this.$router.push(
                  "/workflow/" +
                  this.currentWorkflow.workflow_id +
                  "/" +
                  this.currentWorkflow.signer_id +
                  "/authenticate2fa"
                );
              } else {
                this.$router.push(
                  "/workflow/" +
                  this.currentWorkflow.workflow_id +
                  "/" +
                  this.currentWorkflow.signer_id +
                  "/identify"
                );
              }
              break;

            case "q_signature":
              if (res.signer_exists && res.certificate_exists) {
                this.$router.push(
                  "/workflow/" +
                  this.currentWorkflow.workflow_id +
                  "/" +
                  this.currentWorkflow.signer_id +
                  "/authenticate2fa"
                );
              } else {
                this.$router.push(
                  "/workflow/" +
                  this.currentWorkflow.workflow_id +
                  "/" +
                  this.currentWorkflow.signer_id +
                  "/identify"
                );
              }
              break;
          }
        })
        .catch((err) => {
          log(
            "MainPage.Certificate.getCertificate() - " + err.message,
            "error"
          );
        });
    },
    startEditor(file) {
      this.currentFile = file;
      this.showEditor = true;
    },
    getIcon(item) {
      if (item.completed) {
        return "mdi-check-circle-outline";
      } else {
        return "mdi-checkbox-blank-circle-outline";
      }
    },
    setFinished(currentFile) {
      this.files.forEach((file) => {
        if (file.id === currentFile.id) {
          file.completed = true;
          if(this.multipleFiles){
            this.showEditor = false
          }
        }
      });
    },

  },
};
</script>
